import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import CardBookingSpecific2 from "../components/CardBookingSpecific2";
import FetchNoLogin from "../components/Fetch/FetchNoLogin";

const BookingCheck = () => {
	const params = useParams();
	const [v, setV] = useState({
		bookDetails: {},
	});

	const reqBookSpecific = FetchNoLogin("booking-specific", {
		data: {
			bookNo: params.bookingNo,
		},
		callback: (cb) => {
			setV2({ bookDetails: cb.response.data });
		},
	});

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	useEffect(() => {
		reqBookSpecific.handleTrigger();
		// eslint-disable-next-line
	}, []);

	return (
		<CardBookingSpecific2 bet={v.bookDetails} leftSide="-1" e_date={true} />
	);
};

export default BookingCheck;
